import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ApprovalCounts {
  purchaseOrders: number;
  jobOrders: number;
  changeOrders: number;
  invoices: number;
}

export const useApprovalCounts = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["approval_counts", user?.id],
    queryFn: async (): Promise<ApprovalCounts> => {
      const [po, jo, co, inv] = await Promise.all([
        supabase.from("purchase_orders").select("id", { count: "exact", head: true }).in("status", ["draft", "submitted"]),
        supabase.from("job_orders").select("id", { count: "exact", head: true }).in("status", ["draft", "submitted"]),
        supabase.from("change_orders").select("id", { count: "exact", head: true }).in("status", ["draft", "submitted"]),
        supabase.from("invoices").select("id", { count: "exact", head: true }).eq("status", "draft").is("deleted_at", null),
      ]);

      return {
        purchaseOrders: po.count ?? 0,
        jobOrders: jo.count ?? 0,
        changeOrders: co.count ?? 0,
        invoices: inv.count ?? 0,
      };
    },
    enabled: !!user,
  });
};
